import { Record, Static, String as RTString } from 'runtypes';

export const Phone = Record({
  areaCode: RTString,
  exchange: RTString,
  lastFour: RTString,
  type: RTString
});

export type StaticPhone = Static<typeof Phone>;
